import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './index.css';
import './style/lib/animate.css';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import CRouter from './routes';
import {store, persistor} from './store';
import {setInterceptors} from './utils/request';
import DevTools from "./components/DevTools";
import moment from 'moment';
import momentLocale from 'moment/locale/zh-cn';
import {PersistGate} from 'redux-persist/lib/integration/react'


setInterceptors(store);


moment.updateLocale('zh-cn', momentLocale)
const useDevTools = process.env.NODE_ENV === 'development';

const contentElement = useDevTools ?
    <div style={{height: " 100%"}}>
        <CRouter store={store}/>
        <DevTools/>
    </div>
    :
    <CRouter store={store}/>

const renderElement =
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            {contentElement}
        </PersistGate>
    </Provider>


ReactDOM.render(renderElement, document.getElementById('root'));
registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js